import { render } from "./accaModal-medium.vue?vue&type=template&id=5fa834d0&scoped=true"
import script from "./accaModal-medium.vue?vue&type=script&lang=js"
export * from "./accaModal-medium.vue?vue&type=script&lang=js"

import "./accaModal-medium.vue?vue&type=style&index=0&id=5fa834d0&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa834d0"]])

export default __exports__